module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"targetTitle":"Weekly Sales Target - Previous year result","totalSales1":"Total Sales(from 1st of","totalSales2":"the month to this week)","monthlySalesTarget1":"This Month\u0027s Sales","monthlySalesTarget2":"Target","lastYearSales1":"Previous Year Same","lastYearSales2":"Month’s Sales","remaining":"Remaining","progress":"Progress"}}')
  delete Component.options._Ctor
}
